import { Box, Typography } from '@mui/material';
import { StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { StructuredContentRenderer } from '@repo/ui/StructuredContentRenderer';
import { CheckIcon } from './CheckIcon';

export const ProsItems = ({ pro }: { pro?: StructuredContentDocument | string }) => {
  return (
    <Box sx={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
      <CheckIcon />
      {typeof pro === 'string' ? (
        <Typography>{pro}</Typography>
      ) : (
        <StructuredContentRenderer doc={pro} />
      )}
    </Box>
  );
};
